import { callApi, callApiWithRawResponse } from "../helpers/callApi";
import { autoFormat, autoNormalize } from "./autoNormalize";

export const API = {
  call: callApi,
  callRaw: callApiWithRawResponse,
  autoFormat,
  autoNormalize,
};
